class ExternalEventProcesser {
  processPresentation(data) {
    return new Promise(resolve => {
      if (typeof data !== 'object' || data.type !== 'qpd' || !Array.isArray(data.presentation.items)) {
        return resolve({
          activeMode: 'PIP',
          items: []
        });
      }

      return import('@/repositories/QPV/QPVSlidesMapper').then(module => {
        const mapper = new module.QPVSlidesMapper(data);
        return resolve(mapper.map())
      })
    })
  }
}

export let externalEventProcesser = new ExternalEventProcesser()
